import { Row } from "antd";
import SearchCategories from "../SearchCategories";
import "./HomeBanner.scss";
import { useRecoilValue } from "recoil";
import { memberState } from "../../state/atoms";
import { MemberDtoPlanEnum } from "../../generated/dashboard-client";
import { NavLink } from "react-router-dom";
import { env } from "../../env/env";

export default function HomeBanner() {
  const member = useRecoilValue(memberState);

  return ( 
    <Row>
      <div className={`home-banner dsab`}>
        <div className="mobile-search-cats">
          <SearchCategories />
        </div>

        {member.plan !== MemberDtoPlanEnum.Free &&
        <div className="review-banner">
          <div className="red-shapes"/>
          <img className="stars" src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/ReviewStars.svg" alt="five white stars"/>
          <div className="banner-body">
            <div className="review-text">
              <b>Happy? Help us get the word out.</b><br/>
              Please leave a review!
            </div>
            <div className="btn-cont">
              <a className="ant-btn ant-btn-lg secondary-two" href="https://reviews.capterra.com/products/new/11b8d91a-c245-4260-9038-bc07a61f5c08/43ef40e5-6615-4a35-87ba-68078ff3af49/?lang=en" target="_blank" rel="noreferrer">Leave a review</a>
            </div>
          </div>
        </div>}

        {member.plan === MemberDtoPlanEnum.Free &&
        <div className="dsa-banner">
          <div className="video-container">
            <video src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/DSAGeometricBanner.mp4" autoPlay loop muted playsInline/>
          </div>
          <div className="left-section">
            <div className="dsa-title">
              <img className="hero" src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/DSABannerHero.webp" alt="hero"/>
              <div>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/DSATeal.svg" alt="DSA icon"/>
                <h2>Display</h2>
              </div>
              <div className="separator"/>
              <h3>Goodbye, thumb drive!</h3>
            </div>
          </div>
          <div className="right-section">
            <a className="ant-btn ant-btn-lg" href="/feature/digital-menu-board-solution.html" target="_blank" rel="noreferrer">Learn More</a>
            <NavLink to={`${env.dashboardPath}/dsa/manage`} className="ant-btn ant-btn-lg try-out">Try It Out</NavLink>
          </div>
        </div>}
      </div>
    </Row>
  );
}
